import Table from '@tiptap/extension-table';
import getTableNodeTypes from '@tiptap/extension-table';

export const CustomTable = Table.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      customStyle: {
        default: null,
        renderHTML: () => {
          return {
            style:
              'border-collapse: separate; border-spacing: 0; table-layout: fixed; margin: 0; font-size: 14px; font-family: Arial, sans-serif;border: 2px solid #ced4da;',
          };
        },
      },
      width: {
        default: null,
        parseHTML: (element) => element.getAttribute('width'),
        renderHTML: (attributes) => {
          if (!attributes.width) return {};
          return {
            width: attributes.width,
            style: `width: ${attributes.width}px; min-width: ${attributes.width}px; max-width: ${attributes.width}px;`,
          };
        },
      },
    };
  },

  addOptions() {
    return {
      ...this.parent?.(),
      resizable: true,
      getTableNodeTypes: getTableNodeTypes,
    };
  },
});
